const vP18171 = require("./120.js");
const vP181712 = require("./297.js");
const vP181713 = require("./358.js");
const vP181714 = require("./359.js");
const vP181715 = require("./360.js");
const vP181716 = require("./361.js");
const vP181717 = require("./362.js");
const vP181718 = require("./303.js");
const vP181719 = require("./363.js");
const vP1817110 = require("./366.js");
const vP1817111 = require("./367.js");
const vP1817112 = require("./121.js");
const vP1817113 = require("./368.js");
function f2160(p18172, p18173) {
  const v13963 = p18172.size;
  const v13964 = vP181716.getPositions(p18173);
  for (let vLN02553 = 0; vLN02553 < v13964.length; vLN02553++) {
    const v13965 = v13964[vLN02553][0];
    const v13966 = v13964[vLN02553][1];
    for (let v13967 = -1; v13967 <= 7; v13967++) {
      if (!(v13965 + v13967 <= -1) && !(v13963 <= v13965 + v13967)) {
        for (let v13968 = -1; v13968 <= 7; v13968++) {
          if (!(v13966 + v13968 <= -1) && !(v13963 <= v13966 + v13968)) {
            if (v13967 >= 0 && v13967 <= 6 && (v13968 === 0 || v13968 === 6) || v13968 >= 0 && v13968 <= 6 && (v13967 === 0 || v13967 === 6) || v13967 >= 2 && v13967 <= 4 && v13968 >= 2 && v13968 <= 4) {
              p18172.set(v13965 + v13967, v13966 + v13968, true, true);
            } else {
              p18172.set(v13965 + v13967, v13966 + v13968, false, true);
            }
          }
        }
      }
    }
  }
}
function f2161(p18174) {
  const v13969 = p18174.size;
  for (let vLN86 = 8; vLN86 < v13969 - 8; vLN86++) {
    const v13970 = vLN86 % 2 == 0;
    p18174.set(vLN86, 6, v13970, true);
    p18174.set(6, vLN86, v13970, true);
  }
}
function f2162(p18175, p18176) {
  const v13971 = vP181715.getPositions(p18176);
  for (let vLN02554 = 0; vLN02554 < v13971.length; vLN02554++) {
    const v13972 = v13971[vLN02554][0];
    const v13973 = v13971[vLN02554][1];
    for (let v13974 = -2; v13974 <= 2; v13974++) {
      for (let v13975 = -2; v13975 <= 2; v13975++) {
        if (v13974 === -2 || v13974 === 2 || v13975 === -2 || v13975 === 2 || v13974 === 0 && v13975 === 0) {
          p18175.set(v13972 + v13974, v13973 + v13975, true, true);
        } else {
          p18175.set(v13972 + v13974, v13973 + v13975, false, true);
        }
      }
    }
  }
}
function f2163(p18177, p18178) {
  const v13976 = p18177.size;
  const v13977 = vP1817110.getEncodedBits(p18178);
  let v13978;
  let v13979;
  let v13980;
  for (let vLN02555 = 0; vLN02555 < 18; vLN02555++) {
    v13978 = Math.floor(vLN02555 / 3);
    v13979 = vLN02555 % 3 + v13976 - 8 - 3;
    v13980 = (v13977 >> vLN02555 & 1) == 1;
    p18177.set(v13978, v13979, v13980, true);
    p18177.set(v13979, v13978, v13980, true);
  }
}
function f2164(p18179, p18180, p18181) {
  const v13981 = p18179.size;
  const v13982 = vP1817111.getEncodedBits(p18180, p18181);
  let v13983;
  let v13984;
  for (v13983 = 0; v13983 < 15; v13983++) {
    v13984 = (v13982 >> v13983 & 1) == 1;
    if (v13983 < 6) {
      p18179.set(v13983, 8, v13984, true);
    } else if (v13983 < 8) {
      p18179.set(v13983 + 1, 8, v13984, true);
    } else {
      p18179.set(v13981 - 15 + v13983, 8, v13984, true);
    }
    if (v13983 < 8) {
      p18179.set(8, v13981 - v13983 - 1, v13984, true);
    } else if (v13983 < 9) {
      p18179.set(8, 15 - v13983 - 1 + 1, v13984, true);
    } else {
      p18179.set(8, 15 - v13983 - 1, v13984, true);
    }
  }
  p18179.set(v13981 - 8, 8, 1, true);
}
function f2165(p18182, p18183) {
  const v13985 = p18182.size;
  let v13986 = -1;
  let v13987 = v13985 - 1;
  let vLN73 = 7;
  let vLN02556 = 0;
  for (let v13988 = v13985 - 1; v13988 > 0; v13988 -= 2) {
    for (v13988 == 6 && v13988--;;) {
      for (let vLN02557 = 0; vLN02557 < 2; vLN02557++) {
        if (!p18182.isReserved(v13987, v13988 - vLN02557)) {
          let v13989 = false;
          if (vLN02556 < p18183.length) {
            v13989 = (p18183[vLN02556] >>> vLN73 & 1) == 1;
          }
          p18182.set(v13987, v13988 - vLN02557, v13989);
          vLN73--;
          if (vLN73 === -1) {
            vLN02556++;
            vLN73 = 7;
          }
        }
      }
      v13987 += v13986;
      if (v13987 < 0 || v13985 <= v13987) {
        v13987 -= v13986;
        v13986 = -v13986;
        break;
      }
    }
  }
}
function f2166(p18184, p18185, p18186) {
  const v13990 = new vP181713();
  p18186.forEach(function (p18187) {
    v13990.put(p18187.mode.bit, 4);
    v13990.put(p18187.getLength(), vP1817112.getCharCountIndicator(p18187.mode, p18184));
    p18187.write(v13990);
  });
  const v13991 = vP18171.getSymbolTotalCodewords(p18184);
  const v13992 = vP181718.getTotalCodewordsCount(p18184, p18185);
  const v13993 = (v13991 - v13992) * 8;
  for (v13990.getLengthInBits() + 4 <= v13993 && v13990.put(0, 4); v13990.getLengthInBits() % 8 != 0;) {
    v13990.putBit(0);
  }
  const v13994 = (v13993 - v13990.getLengthInBits()) / 8;
  for (let vLN02558 = 0; vLN02558 < v13994; vLN02558++) {
    v13990.put(vLN02558 % 2 ? 17 : 236, 8);
  }
  return f2167(v13990, p18184, p18185);
}
function f2167(p18188, p18189, p18190) {
  const v13995 = vP18171.getSymbolTotalCodewords(p18189);
  const v13996 = vP181718.getTotalCodewordsCount(p18189, p18190);
  const v13997 = vP181718.getBlocksCount(p18189, p18190);
  const v13998 = Math.floor(v13995 / v13997);
  const v13999 = Math.floor((v13995 - v13996) / v13997);
  const v14000 = v13998 - v13999;
  const v14001 = new vP181719(v14000);
  let vLN02559 = 0;
  const vArray60 = Array(v13997);
  const vArray61 = Array(v13997);
  let vLN02560 = 0;
  const v14002 = new Uint8Array(p18188.buffer);
  for (let vLN02561 = 0; vLN02561 < v13997; vLN02561++) {
    const v14003 = vLN02561 < v13997 - v13995 % v13997 ? v13999 : v13999 + 1;
    vArray60[vLN02561] = v14002.slice(vLN02559, vLN02559 + v14003);
    vArray61[vLN02561] = v14001.encode(vArray60[vLN02561]);
    vLN02559 += v14003;
    vLN02560 = Math.max(vLN02560, v14003);
  }
  const v14004 = new Uint8Array(v13995);
  let v14005;
  let v14006;
  let vLN02562 = 0;
  for (v14005 = 0; v14005 < vLN02560; v14005++) {
    for (v14006 = 0; v14006 < v13997; v14006++) {
      if (v14005 < vArray60[v14006].length) {
        v14004[vLN02562++] = vArray60[v14006][v14005];
      }
    }
  }
  for (v14005 = 0; v14005 < v14000; v14005++) {
    for (v14006 = 0; v14006 < v13997; v14006++) {
      v14004[vLN02562++] = vArray61[v14006][v14005];
    }
  }
  return v14004;
}
function f2168(p18191, p18192, p18193, p18194) {
  let v14007;
  if (Array.isArray(p18191)) {
    v14007 = vP1817113.fromArray(p18191);
  } else if (typeof p18191 == "string") {
    let vP18192 = p18192;
    if (!vP18192) {
      const v14008 = vP1817113.rawSplit(p18191);
      vP18192 = vP1817110.getBestVersionForData(v14008, p18193);
    }
    v14007 = vP1817113.fromString(p18191, vP18192 || 40);
  } else {
    throw new Error("Invalid data");
  }
  const v14009 = vP1817110.getBestVersionForData(v14007, p18193);
  if (!v14009) {
    throw new Error("The amount of data is too big to be stored in a QR Code");
  }
  if (!p18192) {
    p18192 = v14009;
  } else if (p18192 < v14009) {
    throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + v14009 + ".\n");
  }
  const vF2166 = f2166(p18192, p18193, v14007);
  const v14010 = vP18171.getSymbolSize(p18192);
  const v14011 = new vP181714(v14010);
  f2160(v14011, p18192);
  f2161(v14011);
  f2162(v14011, p18192);
  f2164(v14011, p18193, 0);
  if (p18192 >= 7) {
    f2163(v14011, p18192);
  }
  f2165(v14011, vF2166);
  if (isNaN(p18194)) {
    p18194 = vP181717.getBestMask(v14011, f2164.bind(null, v14011, p18193));
  }
  vP181717.applyMask(p18194, v14011);
  f2164(v14011, p18193, p18194);
  return {
    modules: v14011,
    version: p18192,
    errorCorrectionLevel: p18193,
    maskPattern: p18194,
    segments: v14007
  };
}
exports.create = function (p18195, p18196) {
  if (typeof p18195 == "undefined" || p18195 === "") {
    throw new Error("No input text");
  }
  let v14012;
  let v14013;
  let v14014 = vP181712.M;
  if (typeof p18196 != "undefined") {
    v14014 = vP181712.from(p18196.errorCorrectionLevel, vP181712.M);
    v14012 = vP1817110.from(p18196.version);
    v14013 = vP181717.from(p18196.maskPattern);
    if (p18196.toSJISFunc) {
      vP18171.setToSJISFunction(p18196.toSJISFunc);
    }
  }
  return f2168(p18195, v14012, v14014, v14013);
};